import { BillingInvoice } from "../../../components/billingInvoice";
import { DashboardContainer } from "../../../components/dashboard/DashboardContainer";

const Billing = () => (
  <DashboardContainer>
    <BillingInvoice />
  </DashboardContainer>
);

export default Billing;